// View-only feedback: floating numbers, screen shake, turn banner, tap bounce. Never touches game state.
const reduce = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export function floatText(x, y, text, kind = "dmg") {
  const el = document.createElement("div");
  el.className = `float-num ${kind}`;
  el.textContent = text;
  el.style.left = `${x}px`;
  el.style.top = `${y}px`;
  document.body.appendChild(el);
  setTimeout(() => el.remove(), 1100);
}

export function shake(strength = 1) {
  if (reduce()) return;
  const b = document.getElementById("board");
  b.style.setProperty("--shake", `${4 * strength}px`);
  b.classList.remove("shake");
  void b.offsetWidth;
  b.classList.add("shake");
}

let bannerTimer = 0;
export function banner(text, kind = "you") {
  const el = document.getElementById("turn-banner");
  if (!el) return;
  el.textContent = text;
  el.className = `turn-banner ${kind}`;
  el.hidden = false;
  void el.offsetWidth;
  el.classList.add("show");
  clearTimeout(bannerTimer);
  bannerTimer = setTimeout(() => { el.classList.remove("show"); el.hidden = true; }, 1300);
}

// Bounce any chunky button on press.
export function bindBounce() {
  document.addEventListener("pointerdown", (e) => {
    const b = e.target.closest("button, .deck-card");
    if (!b || b.disabled || reduce()) return;
    b.classList.remove("pop");
    void b.offsetWidth;
    b.classList.add("pop");
  }, { passive: true });
}
